import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import { Link } from "react-router-dom";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { TrasladosTab } from "../tabs/TrasladosTab/TrasladosTab";
import { FinalizadosTab } from "../tabs/FinalizadosTab/FinalizadosTab";
import "../styles/ListadoTraslados.css";

class EnvioTraslados extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "PENDIENTES";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });

            sessionStorage.removeItem("traslados_envio_tab_pendiente_state");
            sessionStorage.removeItem("traslados_envio_tab_en_transito_state");
            sessionStorage.removeItem("traslados_envio_tab_recibido_state");
            sessionStorage.removeItem("traslados_envio_tab_finalizado_state");
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="traslados_activo"
                    titulo="TRASLADOS"
                    subtitulo="Solido"
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}
                    >
                        <TabPane tab="PENDIENTES" key="PENDIENTES">
                            <TrasladosTab
                                estado="pendiente"
                                storageKey="traslados_envio_tab_pendiente_state"
                                modo="envio"
                            />
                        </TabPane>

                        <TabPane tab="EN TRÁNSITO" key="EN_TRANSITO">
                            <TrasladosTab
                                estado="en_transito"
                                storageKey="traslados_envio_tab_en_transito_state"
                                modo="envio"
                            />
                        </TabPane>

                        <TabPane tab="ENTREGADOS" key="ENTREGADOS">
                            <TrasladosTab
                                estado="recibido"
                                storageKey="traslados_envio_tab_recibido_state"
                                modo="envio"
                            />
                        </TabPane>

                        <TabPane tab="FINALIZADOS" key="FINALIZADOS">
                            <FinalizadosTab
                                estado="finalizado"
                                storageKey="traslados_envio_tab_finalizado_state"
                                modo="envio"
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

export default EnvioTraslados;
